var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"title":_vm.title,"cancelText":_vm.onRefuse ? 'Refuser' : 'Annuler',"okText":"Confirmer","effect":"fade/zoom"},on:{"cancel":_vm.close,"ok":_vm.confirm},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }